import React from 'react';
import GlobalStyle from './src/global-styles';

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <GlobalStyle />
      {element}
    </>
  );
};
